import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "col" }
const _hoisted_2 = { class: "subGrid mtop-03" }
const _hoisted_3 = { style: {"grid-column":"left"} }
const _hoisted_4 = {
  style: {"grid-column":"right"},
  class: "row"
}
const _hoisted_5 = { style: {"grid-column":"left"} }
const _hoisted_6 = {
  style: {"grid-column":"right"},
  class: "row"
}
const _hoisted_7 = { style: {"grid-column":"left"} }
const _hoisted_8 = {
  style: {"grid-column":"right"},
  class: "row"
}
const _hoisted_9 = {
  key: 0,
  class: "mtop-20 bg-blue-04 pad-m rnd-m"
}
const _hoisted_10 = {
  key: 1,
  class: "mtop-20 bg-blue-04 pad-m rnd-m"
}
const _hoisted_11 = { class: "mtop-04" }
const _hoisted_12 = { class: "mtop-02" }
const _hoisted_13 = {
  key: 0,
  class: "mtop-02"
}
const _hoisted_14 = {
  key: 1,
  class: "mtop-02"
}
const _hoisted_15 = {
  key: 2,
  class: "mtop-20 bg-blue-04 pad-m rnd-m"
}
const _hoisted_16 = { class: "mtop-02" }
const _hoisted_17 = { class: "mtop-10" }
const _hoisted_18 = { class: "row" }
const _hoisted_19 = {
  key: 3,
  class: "mtop-20 bg-blue-04 pad-m rnd-m"
}
const _hoisted_20 = { class: "mtop-10" }
const _hoisted_21 = { class: "row" }
const _hoisted_22 = { class: "row mtop-15 pad-s" }

import { ref, computed, onMounted, PropType } from 'vue';
import { useI18n } from 'vue-i18n';
import { apiDateString, apiAmountCurrency } from '@/api/apicommon';
import SessionStorageService from '@/services/SessionStorageService';
import { medServerApiConfig } from '@/config/medserver-api.config';
import { useToast } from 'primevue';
import { toastError, toastSuccess } from '@/utils/toast-utils';
import cnsEconnectorApi, { CnsOperationType } from '@/api/cnsEconnectorApi';
import officeapi from '@/api/officeapi';
import patientapi from '@/api/patientapi';
import { CNSApi, FinancialChannelLightResponse, InvoiceResponse, PostCreateCnsLogRequest } from '@/apiGenerate/medserver';
import { extractErrorsFromCnsAnomalie } from '@/api/cnsEconnectorApi';
import PersonService from "@/services/PersonService";


export default /*@__PURE__*/_defineComponent({
  __name: 'luBillCancellation',
  props: {
  invoice: {
    type: Object,
    required: true,
  },
  financialChannel: {
    type: Object as PropType<FinancialChannelLightResponse>,
    required: true,
  },
  financialGroupId: {
    type: Number,
    required: true,
  },
  mockMode: {
    type: String,
    required: true,
  },
  eConnectorApiError: {
    type: Boolean,
    required: true,
  },
  eConnectorActivated: {
    type: Boolean,
    required: true,
  },
},
  emits: ['reload'],
  setup(__props, { emit: __emit }) {

const toast = useToast();
const { t } = useI18n();
const cnsApi = new CNSApi(medServerApiConfig);
const MockMode = {
  OFF: 'off',
  ECONNECTOR_DISABLED: 'mockEconnectorDisabled',
  ECONNECTOR_NO_PORT: 'mockEconnectorNoPort',
  ECONNECTOR_ERROR: 'mockEconnectorError',
  PID_REFUSED: 'mockPidRefused',
  PID_OK: 'mockPidOk',
} as const;

const props = __props

const emits = __emit

const eConnectorAwaiting = ref<boolean>(false);
const cancellationReasonRef = ref<HTMLInputElement | null>(null)

const luBillEtransferData = ref<string | undefined>(props.invoice.patientDocument?.luBillEtransferData);
const cancellationReason = ref<string>(props.invoice.patientDocument?.luBillEtransferData?.cancellationReason || "");
const currInvoice = ref<InvoiceResponse>(props.invoice);
const isPending = ref<boolean>(false);

const personName = computed(() => {
  const pwr = currInvoice.value.pwrCounterParty;
  return PersonService.formatName(pwr.lastName, pwr.firstName);
})

const hasCns = computed(() => props.invoice.pwrCounterParty.hasCns);

const isEConnectorAvailable = computed(() => {
  return props.eConnectorActivated && !props.eConnectorApiError;
})

const isAlreadyCancelledViaEconnector = computed(() => {
  return !!luBillEtransferData.value?.raCancellationTimestamp;
})

const canPerformSimpleCancellation = computed(() => {
  if (isAlreadyCancelledViaEconnector.value) return false;
  if (props.invoice.invoiceStatus === "Precomplete") return true;
  if (props.invoice.isCancellableByEConnector) return false;
  return true;
})

const canPerformEConnectorCancellation = computed(() => {
  if (isAlreadyCancelledViaEconnector.value) return false;
  if (props.invoice.invoiceStatus === "Precomplete") return false;
  if (!hasCns.value) return false;
  return props.invoice.isCancellableByEConnector;
})

const hasCancellationReason = computed(() => {
  return cancellationReason.value.trim() !== '';
})

// eConnector calls
async function callEconnectorCancelMh(invoiceId: number): Promise<{ success: boolean, errorDetails?: string }> {
  // MOCK
  if (props.mockMode !== MockMode.OFF) {
    await new Promise(resolve => setTimeout(resolve, 1000));
    if (props.mockMode === MockMode.ECONNECTOR_ERROR) {
      return { success: false, errorDetails: '- Mock: Cancel MH failed' };
    }
    return { success: true };
  }

  // REAL
  const port = SessionStorageService.getItem('cnsEconnectorApiPort');
  const raCancelRequest = await cnsApi.postRaCancelMh({ raCancelMhRequest: { invoiceId: invoiceId } });
  const cnsResponse = await cnsEconnectorApi.cancelMh(port, raCancelRequest.gpCode, raCancelRequest.xmlRequest);

  const errorsMap = extractErrorsFromCnsAnomalie(cnsResponse.anomalies);
  let errorDetails = '';
  errorsMap.forEach((value) => {
    errorDetails += '- ' + value + '\n';
  });

  const cnsLogRequest: PostCreateCnsLogRequest = {
    cnsLogRequest: {
      operationType: CnsOperationType.RA_CANCEL_MH.toString(),
      requestContent: raCancelRequest.xmlRequest,
      responseContent: JSON.stringify(cnsResponse),
      status: errorDetails !== '' ? 'NOK' : 'OK',
      timestamp: new Date(),
      financialGroupId: props.financialGroupId
    }
  };
  await cnsApi.postCreateCnsLog(cnsLogRequest);

  return { success: errorDetails === '', errorDetails: errorDetails || undefined };
}

async function updateCancellationReason() {
  const invoiceId = props.invoice.id;
  const oldReason = props.invoice.patientDocument?.luBillEtransferData?.cancellationReason || "";
  const newReason = cancellationReason.value;
  if (oldReason === newReason) return;
  if (luBillEtransferData.value) {
    luBillEtransferData.value.cancellationReason = newReason;
  }
  await patientapi.updateCancellationReason(invoiceId, newReason);
}

async function simpleCancel(invoice: any) {
  if (!canPerformSimpleCancellation.value) return;
  if (!hasCancellationReason.value) { focus(); return; }

  const invoiceId = invoice.id;
  const partial = invoice.partial;
  const cancellationDate = new Date().toISOString();

  try {
    isPending.value = true;

    //Backend finalization
    if (invoice.invoiceStatus === "Precomplete") {
      await officeapi.finalizeInvoiceToUnpaid(invoiceId);
    }
    //Cancellation
    await officeapi.addTransaction(null, props.financialChannel.id.toString(), invoiceId, cancellationDate, partial);
    emits('reload');

  } finally {
    isPending.value = false;
  }
}

async function cancelViaEConnector(invoice: any, targetFinancialChannel: FinancialChannelLightResponse) {
  if (!canPerformEConnectorCancellation.value) return;
  if (!hasCancellationReason.value) { focus(); return; }
  if (targetFinancialChannel.type !== "Cancelled") return;

  const invoiceId = invoice.id;
  const cancellationDate = new Date().toISOString();
  const total = invoice.amount;

  if (eConnectorAwaiting.value) return;
  eConnectorAwaiting.value = true;

  try {

    const eConnectorResult = await callEconnectorCancelMh(invoiceId);

    if (eConnectorResult.success) {
      await officeapi.addTransaction(null, targetFinancialChannel.id.toString(), invoiceId, cancellationDate, total);

      const raCancellationTimestamp = new Date();  //Todo: replace with timeStamp form eConnector response
      const newluBillEtransferData = await patientapi.addRaCancellationToEtransferData(
        invoiceId.toString(),
        raCancellationTimestamp
      );
      luBillEtransferData.value = newluBillEtransferData;

      toastSuccess(toast, {
        summary: t('accounting.econnector.cancelMh.toast.success'),
        life: 5000
      });
    } else {
      toastError(toast, {
        summary: t('accounting.econnector.cancelMh.toast.error'),
        detail: eConnectorResult.errorDetails
          ? t('accounting.econnector.cancelMh.toast.errorWithDetails', { details: '\n' + eConnectorResult.errorDetails })
          : t('accounting.econnector.cancelMh.toast.error'),
        life: 5000
      });
    }

    emits('reload');
  } catch (error) {
    toastError(toast, {
      summary: t('accounting.econnector.cancelMh.toast.error'),
      detail: t('accounting.econnector.service.unspecifiedError'),
      life: 5000
    });
  } finally {
    eConnectorAwaiting.value = false;
  }
}

function focus() {
  cancellationReasonRef.value?.innerRef?.focus()
}

onMounted(() => {
  focus();
})


return (_ctx: any,_cache: any) => {
  const _component_text_item = _resolveComponent("text-item")!
  const _component_button_group = _resolveComponent("button-group")!
  const _component_inputAreaAuto2 = _resolveComponent("inputAreaAuto2")!
  const _component_inputBox = _resolveComponent("inputBox")!

  return (_openBlock(), _createElementBlock("div", {
    style: {"width":"max-content"},
    class: "bg-modal",
    onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _createVNode(_component_text_item, {
          txt: personName.value,
          styles: "font-l"
        }, null, 8, ["txt"])
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_text_item, {
            txt: _unref(t)('accounting.econnector.cancelMh.invoiceNumber'),
            styles: "main-m"
          }, null, 8, ["txt"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_text_item, {
            txt: __props.invoice.invoiceReference,
            class: "mleft-auto",
            styles: "main-m"
          }, null, 8, ["txt"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_text_item, {
            txt: _unref(t)('accounting.econnector.cancelMh.invoiceDate'),
            styles: "main-m"
          }, null, 8, ["txt"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_text_item, {
            txt: _unref(apiDateString)(__props.invoice.invoiceDateTime),
            class: "mleft-auto",
            styles: "main-m"
          }, null, 8, ["txt"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_text_item, {
            txt: _unref(t)('accounting.econnector.cancelMh.total'),
            styles: "main-m"
          }, null, 8, ["txt"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_text_item, {
            txt: _unref(apiAmountCurrency)(__props.invoice.amount, __props.invoice.currencyIso),
            class: "mleft-auto",
            styles: "main-m"
          }, null, 8, ["txt"])
        ])
      ])
    ]),
    (isAlreadyCancelledViaEconnector.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createVNode(_component_text_item, {
            txt: _unref(t)('accounting.econnector.cancelMh.alreadyCancelled'),
            styles: "font-mBold main-l"
          }, null, 8, ["txt"])
        ]))
      : (canPerformEConnectorCancellation.value && !isEConnectorAvailable.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", null, [
              _createVNode(_component_text_item, {
                txt: _unref(t)('accounting.econnector.cancelMh.title'),
                styles: "font-mBold"
              }, null, 8, ["txt"])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_text_item, {
                txt: _unref(t)('accounting.econnector.cancelMh.transmittedViaEconnector')
              }, null, 8, ["txt"])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_text_item, {
                txt: _unref(t)('accounting.econnector.cancelMh.cancellationImpossibleWithoutEconnector'),
                class: "text-error"
              }, null, 8, ["txt"])
            ]),
            (!props.eConnectorActivated)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createVNode(_component_text_item, {
                    txt: _unref(t)('accounting.econnector.cancelMh.econnectorDisabled'),
                    styles: "font-s",
                    class: "text-error"
                  }, null, 8, ["txt"])
                ]))
              : (props.eConnectorApiError)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createVNode(_component_text_item, {
                      txt: _unref(t)('accounting.econnector.cancelMh.econnectorUnavailable'),
                      styles: "font-s",
                      class: "text-error"
                    }, null, 8, ["txt"])
                  ]))
                : _createCommentVNode("", true)
          ]))
        : (canPerformEConnectorCancellation.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createElementVNode("div", null, [
                _createVNode(_component_text_item, {
                  txt: _unref(t)('accounting.econnector.cancelMh.titleEconnector'),
                  styles: "font-mBold"
                }, null, 8, ["txt"])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_text_item, {
                  txt: _unref(t)('accounting.econnector.cancelMh.transmittedViaEconnector'),
                  styles: "font-s main-m"
                }, null, 8, ["txt"])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_button_group, {
                  styles: "border-h pad-s",
                  class: "psides-06",
                  disabled: eConnectorAwaiting.value || !hasCancellationReason.value,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (cancelViaEConnector(currInvoice.value, __props.financialChannel)))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createVNode(_component_text_item, {
                        txt: _unref(t)('accounting.econnector.cancelMh.title'),
                        styles: "font-mBold",
                        class: "text-error"
                      }, null, 8, ["txt"]),
                      _createElementVNode("div", _hoisted_18, [
                        _createVNode(_component_text_item, {
                          txt: _unref(apiAmountCurrency)(__props.invoice.amount, __props.invoice.currencyIso),
                          class: "text-error"
                        }, null, 8, ["txt"])
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _createElementVNode("div", null, [
                _createVNode(_component_text_item, {
                  txt: _unref(t)('accounting.econnector.cancelMh.title'),
                  styles: "font-mBold"
                }, null, 8, ["txt"])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_component_button_group, {
                  styles: "border-h pad-s",
                  class: "psides-06",
                  disabled: isPending.value || !hasCancellationReason.value,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (simpleCancel(currInvoice.value)))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createVNode(_component_text_item, {
                        txt: _unref(t)('accounting.econnector.cancelMh.cancelAmount'),
                        styles: "font-mBold"
                      }, null, 8, ["txt"]),
                      _createElementVNode("div", _hoisted_21, [
                        _createVNode(_component_text_item, {
                          txt: _unref(apiAmountCurrency)(__props.invoice.partial, __props.invoice.currencyIso)
                        }, null, 8, ["txt"])
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ])
            ])),
    (!isAlreadyCancelledViaEconnector.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
          _createElementVNode("div", _hoisted_22, [
            _createVNode(_component_text_item, {
              txt: _unref(t)('accounting.econnector.cancelMh.cancellationReason'),
              styles: "font-mBold"
            }, null, 8, ["txt"]),
            (!hasCancellationReason.value)
              ? (_openBlock(), _createBlock(_component_text_item, {
                  key: 0,
                  txt: _unref(t)('accounting.econnector.cancelMh.required'),
                  class: "mleft-auto text-error",
                  styles: "font-s"
                }, null, 8, ["txt"]))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_inputBox, null, {
            default: _withCtx(() => [
              _createVNode(_component_inputAreaAuto2, {
                ref_key: "cancellationReasonRef",
                ref: cancellationReasonRef,
                modelValue: cancellationReason.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((cancellationReason).value = $event)),
                onBlur: _cache[3] || (_cache[3] = ($event: any) => (updateCancellationReason()))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})